import { render, staticRenderFns } from "./_settings.vue?vue&type=template&id=1280c154&lang=pug&"
import script from "./_settings.vue?vue&type=script&lang=js&"
export * from "./_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports